import _ from 'lodash';
import moment from 'moment';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    id_proceso: '',
    fecha_proceso: '',
    asesor: {
        nombre: "",
        celular: "",
        email: ""
    },
    vehiculo: {
        placa: "",
        marca: "",
        linea: "",
        version: "",
        modelo: ""
    },
    comprador: {
        nombre: "",
        tipo_documento: "",
        documento: "",
        celular: "",
        email: "",
        ubicacion: ""
    },
    vendedor: {
        nombre: "",
        tipo_documento: "",
        documento: "",
        celular: "",
        email: "",
        ubicacion: ""
    },
    chequeo_card: {
        title: '',
        photo: '',
        selector: ''
    },
    facturacion: {},
    valores_total: {},
    adminventa: {
        documentos: {},
        vehiculo: {
            transito: {}
        },
        comprador: {},
        vendedor: {},
        asesor: {},
        ubicacion: {},
        canales: [],
        facturacion: {},
        estado_principal: {},
        tab_status: [],
        proceso: {
            cierre: {
                comprador: {
                    canales: [],
                    datos_personales: {},
                    resumen: {
                        credito: {},
                        retoma: {}
                    }
                },
            },
            tramite: {
                checklist: {},
                gastos_traspaso: {
                    comprador: {},
                    gastos: {},
                    impuestos: [],
                    liquidacion: {},
                    vendedor: {}
                },
                multas: {},
                seguimiento: {
                    checklist: {},
                    historial: []
                },
                tramitador: {}
            },
            entrega: {
                acta_entrega: {},
                agendar_form: {},
            },
            alistamiento: {}
        },
        soporte: {
            comprador: [],
            vendedor: []
        },
        historial: [],
        acciones: {}
    },
    consignacion: {
        vehiculo: {
            id_referencia: {},
            meta_keys: {}
        },
        cliente: {},
        asesor: {},
        estado_principal: {},
        tab_status: [],
        proceso: {
            reportar: [],
            cotizado: {
                cotizacionForm: {}
            },
            avaluo: {
                avaluoForm: {},
                cotizacion: {}
            },
            cierre: {
                citaForm: {},
                documentos: {},
                notification_send: {},
                payu: {}
            },
            inspeccion_legal: {
                gastos_traspaso: {
                    comprador: {},
                    gastos: {},
                    impuestos: [],
                    liquidacion: {},
                    vendedor: {}
                },
                propietario: {
                    propietario_ubicacion: {}
                },
                vehiculo: {
                    documentos: {},
                    transito: {},
                    reclamaciones: []
                }
            },
            inspeccion_mecanica: {
                inspeccion: {},
                inspeccion_resultado: {
                    accesorios: {
                        confort: [],
                        exterior: [],
                        multimedia: [],
                        seguridad: []
                    },
                    consola: {
                        carteras_puertas: {},
                        luces_internas: {},
                        rejilla_aire: {},
                        retrovisor_derecho: {},
                        retrovisor_izquierdo: {},
                        tapiceria_techo: {}
                    },
                    encuesta: {},
                    exterior: {
                        bomper_delantero: {},
                        bomper_trasero: {},
                        capot: {},
                        estribo_derecho: {},
                        estribo_izquierdo: {},
                        exploradora_derecha: {},
                        exploradora_izquierda: {},
                        farola_derecha: {},
                        farola_izquierda: {},
                        guardafangos_delantero_der: {},
                        guardafangos_delantero_izq: {},
                        guardafangos_trasero_der: {},
                        guardafangos_trasero_izq: {},
                        llanta_delantera_der: {},
                        llanta_delantera_izq: {},
                        llanta_trasera_der: {},
                        llanta_trasera_izq: {},
                        luz_trasera_der: {},
                        luz_trasera_izq: {},
                        panoramico: {},
                        panoramico_trasero: {},
                        puerta_conductor: {},
                        puerta_copiloto: {},
                        puerta_trasera_izquierda: {},
                        stop_trasero: {},
                        sunroof: {},
                        tapa_baul: {},
                        techo: {},
                        vidrio_conductor: {},
                        vidrio_copiloto: {},
                        vidrio_trasero_derecho: {},
                        vidrio_trasero_izquierdo: {}
                    },
                    fotos: {},
                    interior: {
                        alfombra_piso: {},
                        cinturon_seguridad: {},
                        consola_central: {},
                        freno_mano: {},
                        guantera: {},
                        llanta_repuesto: {},
                        millare: {},
                        palanca_cambios: {},
                        radio: {},
                        tapiceria_asientos: {},
                        volante: {}
                    }
                }
            },
            mercadeo: {},
            ficha_inventario: {}
        },
        inspeccion: {
            asesor: {},
            cliente: {},
            estado_principal: {},
            historial: [],
            proceso: {},
            tab_status: [],
            vehiculo: {}
        },
        documentos: {},
        comentarios: [],
        historial: [],
        acciones: {},

    },
};
const mutations = {
    updateField,
    updateCarpetaAdminventa: (state, payload) => {
        state.id_proceso = payload._id;
        var createdFormat = moment(payload.created_at).format('DD-MM-YYYY hh:mm A');
        state.fecha_proceso = createdFormat;
        state.asesor = {...payload.asesor};
        state.vehiculo = {...payload.vehiculo};
        state.comprador = {...payload.comprador};
        state.vendedor = {...payload.vendedor};
        state.adminventa.vehiculo = payload.vehiculo;
        state.facturacion = {...payload.facturacion};
        state.valores_total = {
            facturacion_total: payload.facturacion_total,
            pago_total: payload.pagar_total,
            recaudo_total: payload.recaudo_total,
            gastos_comprador: payload.gastos_comprador,
            gastos_vendedor: payload.gastos_vendedor
        };
        const { proceso, soporte, documentos, historial} = payload

        state.adminventa.proceso = {
            ...state.adminventa.proceso,
            cierre: proceso.cierre,
            tramite: proceso.tramite,
            entrega: proceso.entrega,
            carpeta: proceso.carpeta,
        };

        state.adminventa.historial = historial;
        state.adminventa.documentos = documentos;
        
        const soportes_recaudo_comprador = payload.soportes_data.recaudo.soportes_comprador;
        const soportes_pago_comprador = payload.soportes_data.pago.soportes_comprador;
        const soportes_comprador = soportes_recaudo_comprador.concat(soportes_pago_comprador);

        const soportes_recaudo_vendedor = payload.soportes_data.recaudo.soportes_vendedor;
        const soportes_pago_vendedor = payload.soportes_data.pago.soportes_vendedor;
        const soportes_vendedor = soportes_recaudo_vendedor.concat(soportes_pago_vendedor);

        state.adminventa.soporte = {
            ...state.adminventa.soporte,
            comprador: soportes_comprador,
            vendedor: soportes_vendedor
        };

    },
    updateCarpetaConsignacion: (state, payload) => {
        const {vehiculo, cliente, asesor, estado_principal, tab_status, proceso, documentos, comentarios, historial, acciones, inspeccion} = payload
        state.consignacion.vehiculo = {
            ...state.consignacion.vehiculo,
            cod_fasecolda: vehiculo.cod_fasecolda,
            color: vehiculo.color,
            id_referencia: vehiculo.id_referencia,
            kilometraje: vehiculo.kilometraje,
            linea: vehiculo.linea,
            marca: vehiculo.marca,
            meta_keys: vehiculo.meta_keys,
            modelo: vehiculo.modelo,
            precio_publicacion: vehiculo.precio_publicacion,
            tipo_vehiculo: vehiculo.tipo_vehiculo,
            version: vehiculo.version
        };

        state.consignacion.cliente = {
            ...state.consignacion.cliente,
            apellido: cliente.apellido,
            celular: cliente.celular,
            email: cliente.email,
            id: cliente.id,
            nombre: cliente.nombre,
            numero_documento: cliente.numero_documento,
            tipo_documento: cliente.tipo_documento,
            ubicacion_id: cliente.ubicacion_id,
            ubicacion_name: cliente.ubicacion_name,
            whatsapp: cliente.whatsapp,
            whatsapp_checked: cliente.whatsapp_checked
        };

        state.consignacion.asesor = {
            ...state.consignacion.asesor,
            celular: asesor.celular,
            email: asesor.email,
            id: asesor.id,
            nombre: asesor.nombre
        };

        state.consignacion.estado_principal = {
            ...state.consignacion.estado_principal,
            label: estado_principal.label,
            slug: estado_principal.slug
        };

        state.consignacion.tab_status = tab_status;

        state.consignacion.proceso = {
            ...state.consignacion.proceso,
            reportar: proceso.reportar,
            cotizado: proceso.cotizado,
            avaluo: proceso.avaluo,
            cierre: proceso.cierre,
            inspeccion_legal: proceso.inspeccion_legal,
            inspeccion_mecanica: proceso.inspeccion_mecanica,
            mercadeo: proceso.mercadeo,
            ficha_inventario: proceso.ficha_inventario
        };

        state.consignacion.inspeccion = {
            ...state.consignacion.inspeccion,
            asesor: inspeccion.asesor,
            cliente: inspeccion.cliente,
            estado_principal: inspeccion.estado_principal,
            historial: inspeccion.historial,
            proceso: inspeccion.proceso,
            tab_status: inspeccion.tab_status,
            vehiculo: inspeccion.vehiculo
        };

        state.consignacion.documentos = documentos;

        state.consignacion.comentarios = comentarios;

        state.consignacion.historial = historial;

        state.consignacion.acciones = {
            ...state.consignacion.acciones,
            citas: acciones.citas,
            tareas: acciones.tareas,
            notas: acciones.notas
        };
    },

    updateChequeoCard: (state, payload) => {
        state.chequeo_card = payload;
    },  
};

const getters = {
    getField,
};
export default {
    namespaced: true,
    state,
    mutations,
    getters
}